import React from "react";
import { Menu, MenuItem } from "@blueprintjs/core";
import { useLocation, useNavigate } from "react-router-dom";

export default function DashboardSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path: string) => location.pathname === path;

  return (
    <Menu>
      <MenuItem
        icon="folder-open"
        text="Overview"
        active={isActive("/dashboard")}
        onClick={() => navigate("/dashboard")}
      />
    </Menu>
  );
}
